import { Row, Divider } from 'antd';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Checkbox } from 'components/atoms/checkbox';
import { Form } from 'components/atoms/form';
import { InputNumber, Input as PreInput } from 'components/atoms/input';
import { Radio } from 'components/atoms/radio';
import {
  BodyShort01,
  Label01,
  Text01,
  Text03,
  SingleLineEllipsis,
} from 'components/styles';

export const SuffixInput = styled(PreInput)`
  width: 100%;
  margin-top: var(--spacing-02);
`;
export const PrefixInput = styled(PreInput)`
  width: 100%;
  margin-top: var(--spacing-02);
  border-right: 1px solid var(--gray-50);
`;
export const Input = styled(InputNumber)`
  width: 87px !important;
`;
export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ParaContainer = styled.p`
  ${BodyShort01};
  ${Text03};
  display: flex;
  align-items: center;
`;
export const SubHeadings = styled.p`
  ${Label01};
  ${Text01};
  margin-bottom: var(--spacing-02);
  color: var(--gray-70) !important;
`;

export const ButtonGroup = styled.div<{
  $space?: number;
  $reversed?: boolean;
  $vertical?: boolean;
}>`
  display: flex;
  flex-direction: ${({ $reversed = false, $vertical = false }) =>
    `${$vertical ? 'column' : 'row'}${$reversed ? '-reverse' : ''}`};
  gap: ${({ $space: $size = 16 }) => `${$size}px`};
  ${Button} {
    flex: 1;
  }
`;
export const SubTitle = styled.p`
  color: var(--gray-50) !important;
  ${SingleLineEllipsis};
  ${BodyShort01};
  ${Text01};
  margin: 0;
`;

export const CheckBox = styled(Checkbox)`
  height: var(--spacing-07);
`;

export const StyledRow = styled(Row)`
  margin-bottom: var(--spacing-04);
  min-height: 0px;
`;

export const StyledFormItem = styled(Form.Item).attrs(
  (props: { hideSpace: boolean }) => props,
)`
  margin-bottom: 0;
  padding-bottom: 0 !important;
  .ant-form-item-control-input {
    min-height: 0px;
  }
  .ant-form-item-control {
    ${(props) => props.hideSpace && 'height: 0px'};
  }
`;

export const DuplicateTaskForm = styled(Form)`
  margin-top: var(--spacing-03);
`;

export const RadioGroup = styled(Radio.Group)`
  font-size: var(--spacing-07);
  font-weight: var(--heading-3-weight);
  margin-top: -8px;
  padding: 0;
`;
export const DividerLine = styled(Divider)`
  margin-bottom: var(--spacing-06);
  margin-top: -16px;
`;
